// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"2d02d38c161bd4c52941","453":"eb5505c9e788d0821004"}[chunkId] + ".js";
};